(function () {
  if (window.__titleFitInitialized) return;
  window.__titleFitInitialized = true;

  const SELECTOR = "[data-fit-title]";
  const DEFAULT_MIN_SIZE = 12;
  const DEFAULT_STEP = 0.5;
  let resizeFrame = null;

  function toPositiveNumber(value) {
    const number = parseFloat(value);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function rememberInlineStyles(node) {
    if (node.dataset.fitPrepared === "true") return;

    node.dataset.fitPrepared = "true";
    node.dataset.fitInlineFontSize = node.style.fontSize || "";
    node.dataset.fitInlineDisplay = node.style.display || "";
    node.dataset.fitInlineOverflow = node.style.overflow || "";
    node.dataset.fitInlineTextOverflow = node.style.textOverflow || "";
    node.dataset.fitInlineWhiteSpace = node.style.whiteSpace || "";
    node.dataset.fitInlineLineClamp = node.style.getPropertyValue("line-clamp") || "";
    node.dataset.fitInlineWebkitLineClamp = node.style.getPropertyValue("-webkit-line-clamp") || "";
    node.dataset.fitInlineWebkitBoxOrient = node.style.getPropertyValue("-webkit-box-orient") || "";
  }

  function restoreInlineStyles(node) {
    node.style.fontSize = node.dataset.fitInlineFontSize || "";
    node.style.display = node.dataset.fitInlineDisplay || "";
    node.style.overflow = node.dataset.fitInlineOverflow || "";
    node.style.textOverflow = node.dataset.fitInlineTextOverflow || "";
    node.style.whiteSpace = node.dataset.fitInlineWhiteSpace || "";

    if (node.dataset.fitInlineLineClamp) {
      node.style.setProperty("line-clamp", node.dataset.fitInlineLineClamp);
    } else {
      node.style.removeProperty("line-clamp");
    }

    if (node.dataset.fitInlineWebkitLineClamp) {
      node.style.setProperty("-webkit-line-clamp", node.dataset.fitInlineWebkitLineClamp);
    } else {
      node.style.removeProperty("-webkit-line-clamp");
    }

    if (node.dataset.fitInlineWebkitBoxOrient) {
      node.style.setProperty("-webkit-box-orient", node.dataset.fitInlineWebkitBoxOrient);
    } else {
      node.style.removeProperty("-webkit-box-orient");
    }
  }

  function getClampLines(node, computedStyle) {
    const rawValue =
      node.dataset.fitLines ||
      computedStyle.getPropertyValue("-webkit-line-clamp") ||
      computedStyle.getPropertyValue("line-clamp");

    return toPositiveNumber(rawValue);
  }

  function fitNode(node) {
    rememberInlineStyles(node);
    restoreInlineStyles(node);

    if (!node.isConnected || node.clientWidth === 0) return;

    const computedStyle = window.getComputedStyle(node);
    const clampLines = getClampLines(node, computedStyle);

    if (!clampLines) return;

    const baseFontSize = toPositiveNumber(computedStyle.fontSize);
    if (!baseFontSize) return;

    const minFontSize = Math.min(
      baseFontSize,
      toPositiveNumber(node.dataset.fitMinSize) || Math.max(DEFAULT_MIN_SIZE, baseFontSize * 0.5)
    );
    const step = Math.min(
      baseFontSize,
      toPositiveNumber(node.dataset.fitStep) || DEFAULT_STEP
    );
    const lineHeight = toPositiveNumber(computedStyle.lineHeight) || baseFontSize * 1.2;
    const lineHeightRatio = lineHeight / baseFontSize;

    node.style.display = "block";
    node.style.overflow = "visible";
    node.style.textOverflow = "clip";
    node.style.whiteSpace = "normal";
    node.style.setProperty("line-clamp", "unset");
    node.style.setProperty("-webkit-line-clamp", "unset");
    node.style.setProperty("-webkit-box-orient", "initial");

    let fontSize = baseFontSize;
    node.style.fontSize = `${fontSize}px`;

    while (fontSize > minFontSize) {
      const maxHeight = fontSize * lineHeightRatio * clampLines + 1;
      const fitsHeight = node.scrollHeight <= maxHeight;
      const fitsWidth = node.scrollWidth <= node.clientWidth + 1;

      if (fitsHeight && fitsWidth) {
        return;
      }

      fontSize = Math.max(minFontSize, fontSize - step);
      node.style.fontSize = `${fontSize}px`;
    }
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;

    if (root.matches && root.matches(SELECTOR)) {
      fitNode(root);
    }

    root.querySelectorAll(SELECTOR).forEach((node) => {
      fitNode(node);
    });
  }

  function queueInit(scope) {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(() => {
      init(scope);
    });
  }

  function watchForNewTitles() {
    if (typeof MutationObserver !== "function") return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(SELECTOR) || node.querySelector(SELECTOR)) {
            queueInit(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
      watchForNewTitles();
    });
  } else {
    init(document);
    watchForNewTitles();
  }

  window.addEventListener("load", function () {
    queueInit(document);
  });

  window.addEventListener("resize", function () {
    queueInit(document);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      queueInit(document);
    });
  }

  document.addEventListener("shopify:section:load", function (event) {
    queueInit(event.target);
  });
})();
